import { render, staticRenderFns } from "./ComplaintsPage.vue?vue&type=template&id=619790ac&scoped=true"
import script from "./ComplaintsPage.vue?vue&type=script&lang=js"
export * from "./ComplaintsPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/finance-compact.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ComplaintsPage.vue?vue&type=style&index=1&id=619790ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619790ac",
  null
  
)

export default component.exports